import { createContext, useContext } from "react";

// The signed-in admin's Finance capabilities, fetched from the backend
// (GET /admin/billing/me/finance-capabilities). The UI only REFLECTS them — the
// backend independently enforces every one on the actual routes, so hiding a
// control here is a courtesy, never the security boundary.
export const FinanceCapsContext = createContext(() => true);

export function useFinanceCan() {
  return useContext(FinanceCapsContext);
}
